import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { NotificationType } from "../../../../../../apis/networkdashboard/graphql/graphql";
import { services } from "../../../../../../app/services";
import { AvailabilityExportItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability-export/availability-export-item";
import { AvailabilityItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/availability/availability-item";
import { MalfunctionItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/malfunction/malfunction-item";
import { SelfServiceItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/self-service/self-service-item";
import { SendConfigItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/send-config/send-config-item";
import { ServiceDocumentationItem } from "../../../../../../components/subscription-detail/shortcut-menu/items/service-documentation/service-documentation";
import { ShortcutMenu } from "../../../../../../components/subscription-detail/shortcut-menu/shortcut-menu";
import { ProductType } from "../../../../../../helpers/enums/productType";
import { L2vpnSubscriptionDetails } from "../../../../../../pages/subscription-detail/types";

@Component({
  selector: "l2vpn-shortcut-menu",
  templateUrl: "l2vpn-shortcut-menu.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AvailabilityItem,
    AvailabilityExportItem,
    MalfunctionItem,
    SelfServiceItem,
    SendConfigItem,
    ServiceDocumentationItem,
    ShortcutMenu,
  ],
})
export class L2vpnShortCutMenu {
  protected subscription = input.required<L2vpnSubscriptionDetails>();
  protected activities = input.required<NotificationType[]>();
  protected subscriptionId = computed(() => this.subscription().subscriptionId);
  protected dirty = computed(() => this.subscription().dirty);

  protected readonly serviceDocumentationUrl = services[ProductType.L2VPN].docs;
}
